import FormSelect from './FormSelect'
import { mapGetters } from 'vuex'
import {
  getCareers
} from '@/api'
export default {
  extends: FormSelect,
  props: {
    config: {
      type: Object,
      default: () => ({
        multiple: false,
      }),
    },
  },
  inject: {
    fetchOptionsOnMount: {
      type: Boolean,
      default: () => (false),
    },
    excludeOptions: {
      type: Array,
      default: () => ([]),
    },
    setAvailableOptions: {
      type: Function,
      default: () => (null),
    },
  },
  data () {
    return {
      isOpen: false,
      isLoading: false,
      options: [],
      optionsLoaded: false,
    }
  },
  mounted () {
    if (this.fetchOptionsOnMount) { this.fetchCareerSelect() }
  },
  computed: {
    ...mapGetters([ 'school' ]),
    mergedConfig () {
      return {
        multiple: false,
        searchable: true,
        options: [],
        ...this.config,
      }
    },
    normalizedOptions () {
      // NOTE: we only want to sort the options loaded in from the BE
      // Any user defined options should retain the sort order in which they were entered
      const optionsArray = Object.values(this.options).map(el => el.description).sort()
      let optionsWithHardCodedOptions = optionsArray.filter(Boolean).concat(this.mergedConfig.options || [])

      if (this.excludeOptions?.value) {
        optionsWithHardCodedOptions = optionsWithHardCodedOptions.filter(option => !this.excludeOptions.value.includes(option))
      }

      // If config.optionsFromAction is non-blank array then some action is triggered
      // and options are filtered based on actions
      const optionsFromAction = this.mergedConfig.optionsFromAction

      if (optionsFromAction && optionsFromAction.length > 0) {
        optionsWithHardCodedOptions = optionsWithHardCodedOptions.filter(option => optionsFromAction.includes(option))
      }
      // ensuring options are unique and sorting the resulting array
      return [ ...new Set(optionsWithHardCodedOptions) ]
    },
  },
  watch: {
    isOpen: {
      async handler (val) {
        if (val && !this.optionsLoaded) {
          await this.fetchCareerSelect()
        }
      },
    },
    normalizedOptions: {
      handler (options) {
        if (!this.setAvailableOptions || typeof this.setAvailableOptions !== 'function') { return }

        this.setAvailableOptions(options)
      },
    },
  },
  methods: {
    async fetchCareerSelect () {
      this.isLoading = true
      const data = await getCareers({ school: this.school, returnFields: [ '_id', 'description' ] }) || {}
      this.options = data
      this.optionsLoaded = true
      this.isLoading = false
    },
  },
}
